import axios from 'axios';

// 创建axios实例
const api = axios.create({
  baseURL: '/api/v1',
  withCredentials: true // 启用跨域Cookie
});

// 请求拦截器，添加token
api.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem('doctor_token');
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 获取待审核报告列表
export const getPendingReports = async (page = 1, pageSize = 10) => {
  try {
    const response = await api.get(`/reports?status=pending&page=${page}&pageSize=${pageSize}`);
    return response.data;
  } catch (error) {
    console.error('获取待审核报告失败', error);
    throw error;
  }
};

// 获取已审核报告列表
export const getReviewedReports = async (page = 1, pageSize = 10) => {
  try {
    const response = await api.get(`/reports?status=approved,rejected&page=${page}&pageSize=${pageSize}`);
    return response.data;
  } catch (error) {
    console.error('获取已审核报告失败', error);
    throw error;
  }
};

// 获取单个报告详情
export const getReportById = async (id) => {
  try {
    const response = await api.get(`/reports/${id}`);
    return response.data;
  } catch (error) {
    console.error(`获取报告ID${id}详情失败`, error);
    throw error;
  }
};

// 通过token获取已审核报告详情（给诊所使用）
export const getReportByIdWithToken = async (id, token) => {
  try {
    const response = await axios.get(`/api/v1/reports/${id}?token=${token}`);
    return response.data;
  } catch (error) {
    console.error(`获取报告ID${id}详情失败`, error);
    throw error;
  }
};

// 获取就诊信息
export const getVisitById = async (visitId) => {
  try {
    const response = await api.get(`/visits/${visitId}`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}详情失败`, error);
    throw error;
  }
};

// 获取患者信息
export const getPatientById = async (patientId) => {
  try {
    const response = await api.get(`/patients/${patientId}`);
    return response.data;
  } catch (error) {
    console.error(`获取患者ID${patientId}详情失败`, error);
    throw error;
  }
};

// 获取患者长期临床资料
export const getPatientClinicalProfile = async (patientId) => {
  try {
    const response = await api.get(`/patients/${patientId}/clinical-profile`);
    return response.data;
  } catch (error) {
    console.error(`获取患者ID${patientId}长期临床资料失败`, error);
    throw error;
  }
};

// 审核报告
export const reviewReport = async (id, data) => {
  try {
    const response = await api.post(`/reports/${id}/review`, data);
    return response.data;
  } catch (error) {
    console.error(`审核报告ID${id}失败`, error);
    throw error;
  }
};

// 更新报告内容
export const updateReportContent = async (id, content) => {
  try {
    const response = await api.patch(`/reports/${id}`, { content });
    return response.data;
  } catch (error) {
    console.error(`更新报告ID${id}内容失败`, error);
    throw error;
  }
};

// 启动后端异步生成报告内容
export const startReportGeneration = async (id, { force = false } = {}) => {
  try {
    const response = await api.post(`/reports/${id}/generate`, { force });
    return response.data;
  } catch (error) {
    console.error(`启动报告ID${id}生成失败`, error);
    throw error;
  }
};

export const retryReportGeneration = async (id) => {
  try {
    const response = await api.post(`/reports/${id}/generation/retry`);
    return response.data;
  } catch (error) {
    console.error(`重试报告ID${id}生成失败`, error);
    throw error;
  }
};

export const createReportRevision = async (id) => {
  try {
    const response = await api.post(`/reports/${id}/revisions`);
    return response.data;
  } catch (error) {
    console.error(`创建报告ID${id}后续版本失败`, error);
    throw error;
  }
};

export const advanceLegacyReport = async (id) => {
  try {
    const response = await api.post(`/reports/${id}/advance`);
    return response.data;
  } catch (error) {
    console.error(`推进历史报告ID${id}失败`, error);
    throw error;
  }
};

// 获取就诊检查项列表
export const getChecksByVisitId = async (visitId) => {
  try {
    // 使用支持医生权限的端点
    const response = await api.get(`/visits/${visitId}/checks`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的检查项失败`, error);
    throw error;
  }
};

// 获取就诊中已完成的 Health House 测量项目
export const getHealthHouseMeasurementsByVisitId = async (visitId) => {
  try {
    const response = await api.get('/health-house/measurements', {
      params: {
        visit_id: visitId,
        completed_only: true
      }
    });
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的Health House检查项目失败`, error);
    throw error;
  }
};

// 通过token获取就诊检查项列表（给诊所使用）
export const getChecksByVisitIdWithToken = async (visitId, token) => {
  try {
    const response = await axios.get(`/api/v1/visits/${visitId}/checks?token=${token}`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的检查项失败`, error);
    throw error;
  }
};

// 根据就诊ID和报告类型获取报告列表
export const getReportsByVisitAndType = async (visitId, reportType) => {
  try {
    const response = await api.get(`/reports/visit/${visitId}/type/${reportType}`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的${reportType}报告失败`, error);
    throw error;
  }
};

// 根据就诊ID和报告类型获取最新报告
export const getLatestReportByVisitAndType = async (visitId, reportType) => {
  try {
    const response = await api.get(`/reports/visit/${visitId}/type/${reportType}/latest`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的最新${reportType}报告失败`, error);
    throw error;
  }
};

// 通过就诊ID获取对话消息列表
export const getConversationMessagesByVisitId = async (visitId) => {
  try {
    const response = await api.get(`/conversations/visit/${visitId}/messages`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的对话消息失败`, error);
    throw error;
  }
};

// 通过对话ID获取对话消息列表
export const getConversationMessagesByConversationId = async (conversationId) => {
  try {
    const response = await api.get(`/conversations/${conversationId}/messages`);
    return response.data;
  } catch (error) {
    console.error(`获取对话ID${conversationId}的对话消息失败`, error);
    throw error;
  }
};

// 获取就诊待检查项列表
export const getPendingChecksByVisitId = async (visitId) => {
  try {
    const response = await api.get(`/visits/${visitId}/pending-checks`);
    return response.data;
  } catch (error) {
    console.error(`获取就诊ID${visitId}的待检查项失败`, error);
    throw error;
  }
};

// 创建待检查项目
export const createPendingCheck = async (data) => {
  try {
    const response = await api.post('/pending-checks', data);
    return response.data;
  } catch (error) {
    console.error('创建待检查项目失败', error);
    throw error;
  }
};

// 审核待检查项目
export const reviewPendingCheck = async (pendingCheckId, data) => {
  try {
    const response = await api.post(`/pending-checks/${pendingCheckId}/review`, data);
    return response.data;
  } catch (error) {
    console.error(`审核待检查项目ID${pendingCheckId}失败`, error);
    throw error;
  }
};

// 删除待检查项目
export const deletePendingCheck = async (pendingCheckId) => {
  try {
    const response = await api.delete(`/pending-checks/${pendingCheckId}`);
    return response.data;
  } catch (error) {
    console.error(`删除待检查项目ID${pendingCheckId}失败`, error);
    throw error;
  }
};

// 创建新报告
export const createReport = async (visitId, reportType = 'final', conversationId) => {
  try {
    const response = await api.post('/reports/create', {
      visit_id: visitId,
      report_type: reportType,
      conversation_id: conversationId
    });
    return response.data;
  } catch (error) {
    console.error(`创建报告失败`, error);
    throw error;
  }
};

// 提交检查结果 - 参考ReportSubmissionView.swift的submitCustomItems方法
export const submitCheckResult = async (data) => {
  try {
    // 构建请求数据，参考ReportSubmissionView.swift中的提交格式
    const requestData = {
      check_type: data.type,
      blob: data.blob,
      metadata: data.metadata,
      blob_mime_type: data.blobType,
      blob_type: data.blobType, // 添加缺少的blob_type字段
      pending_check_id: data.pendingCheckId
    };

    // 如果提供了visitId，添加到请求数据中
    if (data.visitId) {
      requestData.visit_id = data.visitId;
    }

    const response = await api.post('/checks', requestData);
    return response.data;
  } catch (error) {
    console.error('提交检查结果失败', error);
    throw error;
  }
};

// 获取复诊预约单列表
export const getAppointmentOrders = async (params = {}) => {
  try {
    const response = await api.get('/appointment-orders', { params });
    return response.data;
  } catch (error) {
    console.error('获取预约单列表失败', error);
    throw error;
  }
};

// 基于已审核的 final report 追加创建预约单
export const createReportAppointmentOrders = async (reportId, appointmentOrders) => {
  try {
    const response = await api.post(`/reports/${reportId}/appointment-orders`, {
      appointment_orders: appointmentOrders
    });
    return response.data;
  } catch (error) {
    console.error(`为报告ID${reportId}创建预约单失败`, error);
    throw error;
  }
};

// 取消预约单
export const cancelAppointmentOrder = async (id) => {
  try {
    const response = await api.post(`/appointment-orders/${id}/cancel`);
    return response.data;
  } catch (error) {
    console.error(`取消预约单ID${id}失败`, error);
    throw error;
  }
};

// 重置预约单
export const resetAppointmentOrder = async (id) => {
  try {
    const response = await api.post(`/appointment-orders/${id}/reset`);
    return response.data;
  } catch (error) {
    console.error(`重置预约单ID${id}失败`, error);
    throw error;
  }
};
